import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { baselineGrid } from '../utils/presets';
import { toRem, toVW, mqObj as mq } from '../utils/functions';
import { options, rhythm } from '../utils/typography';

const section = css`
  margin: ${toRem(baselineGrid * 6)} 0;

  ${mq.lap} {
    margin: ${toRem(baselineGrid * 8)} 0;
  }

  ${mq.desk} {
    margin: ${toRem(baselineGrid * 10)} 0;
  }
`;

const sectionTitle = css`
  margin: 0;
  padding-top: calc(${toRem(baselineGrid * 5)} + ${toVW(baselineGrid * 5)});
  padding-left: 10vw;
  padding-right: 10vw;
  padding-bottom: ${rhythm(options.blockMarginBottom)};
  text-align: center;
  font-size: calc(${toRem(baselineGrid * 3)} + ${toVW(baselineGrid)});
`;

const Section = ({ title, children }) => (
  <section className={section}>
    {title && <h1 className={sectionTitle}>{title}</h1>}
    {children}
  </section>
);

Section.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/section.js